import { Backdrop, CircularProgress, TextField } from '@mui/material';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import { useEffect, useState } from 'react';
import { Button } from 'react-bootstrap';
import Action from '../../../../action/api';
import API from '../../../helpers/endpointservice';
import CommonIcon from '../../../helpers/icons';


const TeamsConfiguration = ({setValuesChanged}) => {

    let sampleData = {
        "clientId": "",
        "clientSecret": "",
        "microsoftTenantId": ""
    }

    const [formData, setFormData] = useState(sampleData);

    const handleChange = (name, value) => {
        setValuesChanged(true);
        setFormData((prev) => ({
            ...prev,
            [name]: value
        }))
    }

    let initialError = {
        clientId: false,
        clientSecret: false,
        tenantId: false
    }

    const [error, setError] = useState(initialError);

    const handleError = (name, value) => {
        setError((prev) => ({
            ...prev,
            [name]: value
        }))
    }

    const handleValidation = () => {
        let error = false;

        if (formData.clientId.trim() == "" || formData.clientId == null) {
            handleError('clientId', true);
            error = true;
        }
        else {
            handleError('clientId', false);
        }
        if (formData.clientSecret.trim() == "" || formData.clientSecret == null) {
            handleError('clientSecret', true);
            error = true;
        }
        else {
            handleError('clientSecret', false);
        }
        if (formData.microsoftTenantId.trim() == "" || formData.microsoftTenantId == null) {
            handleError('tenantId', true);
            error = true;
        }
        else {
            handleError('tenantId', false);
        }

        return error;
    }

    const handleSubmit = () => {
        if (!handleValidation()) {
            setLoader(true);
            Action.POST(API.MicrosoftMeetings, formData)
                .then((res) => {
                    setLoader(false);
                    getDetails();
                    cancelUpdate();
                    setValuesChanged(false);
                })
                .catch((error) => {
                    console.log(error);
                    setLoader(false);
                })
        }
    }

    const [showUpdate, setshowUpdate] = useState(true);
    const handleUpdate = () => {
        setFormData(clientDetails);
        setshowUpdate(true);
    }

    const cancelUpdate = () => {
        setError(initialError);
        setFormData(clientDetails);
        // setshowUpdate(false);
    }

    const [isloading, setLoader] = useState(false);
    const [clientDetails, setClientDetails] = useState(null);

    const getDetails = () => {
        setLoader(true);
        Action.GET(API.MicrosoftMeetings)
            .then((res) => {
                if (res.data) {
                    setClientDetails(res.data);
                    setFormData(res.data);

                }
                setLoader(false);
            })
            .catch((error) => {
                console.log(error);
                setLoader(false);
            })
    }

    useEffect(() => {
        getDetails();
    }, [])

    return (
        <>
            <Backdrop className="spinner-backdrop" open={isloading}>
                <CircularProgress color="primary" />
            </Backdrop>
            {!showUpdate &&
                <div className='row'>
                    <di className='row'>
                        {/* <div className='col-lg-2 col-md-2 col-sm-12'>
                            <span className="joblable">Microsoft Teams</span>
                        </div> */}
                        <div className='col-lg-12 col-md-12 col-sm-12'>
                            <div className='row'>
                                <div className="col-10  mb-2 ssocontent">
                                    <FormLabel className="formlabel-style w-100 mb-2" id="first-name-label">Client Id</FormLabel>
                                    <span className="wrap">{clientDetails?.clientId}</span>

                                    <FormLabel className="formlabel-style w-100 mt-11 mb-2" id="first-name-label">Client Secret</FormLabel>
                                    <span className="wrap">{clientDetails?.clientSecret}</span>

                                    <FormLabel className="formlabel-style w-100 mt-11 mb-2" id="first-name-label">Tenant Id</FormLabel>
                                    <span className="wrap">{clientDetails?.microsoftTenantId}</span>
                                    <div className='col-12  ssobutton'>
                                        <button className='btn-action mt-10 mr-10 border-none' variant="primary" onClick={() => handleUpdate()} >Edit</button>{' '}

                                    </div>
                                </div>
                            </div>
                        </div>
                    </di>
                </div>
            }
            {showUpdate &&
                <div className='row'>
                    <div className='row'>
                        {/* <div className='col-lg-2 col-md-2 col-sm-12'>
                            <span className="joblable">Microsoft Teams</span>
                        </div> */}
                        <div className='col-lg-12 col-md-12 col-sm-12'>
                            <div className='row'>
                                <div className='col-10'>
                                    <FormLabel className="formlabel-style w-100 mb-2 " id="first-name-label">Client Id</FormLabel>
                                    <TextField
                                        id="ClientId"
                                        variant="filled"
                                        style={{ width: "50%" }}
                                        className="inputwidth"
                                        value={formData.clientId}
                                        error={error.clientId}
                                        helperText={error.clientId ? 'Fill client id' : ""}
                                        onChange={(e) => { handleChange("clientId", e.target.value) }}
                                        focused
                                    />
                                </div>
                                <div className='col-10 mt-2'>
                                    <FormLabel className="formlabel-style w-100 mb-2 " id="first-name-label">Client Secret</FormLabel>
                                    <TextField
                                        id="ClientId"
                                        variant="filled"
                                        style={{ width: "50%" }}
                                        className="inputwidth"
                                        error={error.clientSecret}
                                        helperText={error.clientSecret ? 'Fill client secret' : ""}
                                        value={formData.clientSecret}
                                        onChange={(e) => { handleChange("clientSecret", e.target.value) }}
                                        focused
                                    />
                                </div>
                                <div className='col-10 mt-2'>
                                    <FormLabel className="formlabel-style w-100 mb-2 " id="first-name-label">Tenant Id</FormLabel>
                                    <TextField
                                        id="ClientId"
                                        variant="filled"
                                        style={{ width: "50%" }}
                                        className="inputwidth"
                                        error={error.tenantId}
                                        helperText={error.tenantId ? 'Fill tenant id' : ""}
                                        value={formData.microsoftTenantId}
                                        onChange={(e) => { handleChange("microsoftTenantId", e.target.value) }}
                                        focused
                                    />
                                </div>
                                <div className='col-10 mt-3'>
                                    <button onClick={() => { handleSubmit() }} className={`btn-fun btn-action btn-filter-action`} variant="primary" >Update</button>
                                    {/* <Button className='btn-cancel mt-8' variant="outlined" onClick={() => cancelUpdate()} >Cancel</Button>{' '} */}
                                </div>
                            </div>
                        </div>

                    </div>
                </div >
            }
        </>
    )
}

export default TeamsConfiguration;